import logo from './assets/lib-logo.png';

const header = `
<img class="logo" src="${logo}" alt="Library logo">
<h3 id="count-books">Books(6)</h3>
<h3>Fiction</h3>
<h3>Educative</h3> 
`;

const footer = `
<p>Created by Microverse students: Sebastian and Sylvester under CC license</p>
<div class="footer-grey" >
</div>
`;

export { header, footer };